import { TimepickerFormComponent } from './timepicker-form/timepicker-form.component';
import { DateTimePickerFormComponent } from './date-time-picker-form/date-time-picker-form.component';
import { Directive, Input, ComponentFactoryResolver, ViewContainerRef, OnInit, Renderer2 } from '@angular/core';
import {InputCompComponent , InputNumCompComponent , SelectFormComponent , RadioButtonFormComponent
        , DatepickerFormComponent , CheckboxFormComponent , SelectSearchBoxComponent} from './index';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { UntypedFormGroup } from '@angular/forms';
const componentMapper = {
  TextBox: InputCompComponent,
  NumberBox : InputNumCompComponent,
  DropDown: SelectFormComponent,
  RadioButton : RadioButtonFormComponent,
  DatePicker : DatepickerFormComponent,
  CheckBox: CheckboxFormComponent,
  selectSearchBox: SelectSearchBoxComponent,
  DateTimePicker: DateTimePickerFormComponent,
  TimePicker: TimepickerFormComponent
};
@Directive({
    selector: '[appDynamicField]',
    standalone: false
})
export class DynamicFormFieldDirective implements OnInit {
 @Input() field: FieldConfig;
 @Input() loadFor: string;
 @Input() group: UntypedFormGroup;
 componentRef: any;
 constructor( private resolver: ComponentFactoryResolver,
              private container: ViewContainerRef, private renderer: Renderer2) { }
   ngOnInit() {
     let factory =  null;
     if (this.field.labelCode !== 'GADRAWDAYS' || this.loadFor) {
       if (this.loadFor && (this.field.labelCode === 'SONOID' || this.field.labelCode === 'SSUPER')) {
          factory = this.resolver.resolveComponentFactory(componentMapper.selectSearchBox);
       } else {
        factory = this.resolver.resolveComponentFactory(componentMapper[
          (this.field.type) ? (this.field.type) : 'TextBox']);
       }
       this.componentRef = this.container.createComponent(factory);
       this.componentRef.instance.field = this.field;
       this.componentRef.instance.group = this.group;
       // this.renderer.setAttribute(this.componentRef.location.nativeElement, 'class', 'dynamic-controls');
     }
   }
}



